import Error from '../model/Error';
import axios from 'axios';

export default class ParentUserDuplicationRepository {
    static duplicate(parentUserIds, targetKindergartenId) {
        return new Promise((resolve, reject) => {
            axios
                .post('/parent-user-duplication', {
                    targetKindergartenId,
                    parentUsers: parentUserIds
                })
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }
}
